exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.map-container[data-v-9563fe1a] {\n    width: 100%;\n    height: 500px;\n}\n", ""]);

// exports
